import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";
import { Link } from "gatsby";
import BgImg from "../../../images/case-studies/reckncase/banner-back.webp";

function Banner() {
  return (
    <section
      className="banner_reck"
      style={{ backgroundImage: `url(${BgImg})` }}
    >
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={5} lg={5} xl={4} xxl={4} className="my-auto">
            <div className="banner_box">
              <div className="banner_logo">
                <StaticImage
                  src="../../../images/case-studies/reckncase/logo.webp"
                  alt="TekRevol"
                  className="logo_amj"
                  layout="constrained"
                  placeholder="blurred"
                  formats={["webp"]}
                  width={184}
                  height={152}
                />
              </div>
              <div className="banner_text">
                <p>
                  In a world where dining out sees digital novelty, TekRevol
                  brought the Reck’N mobile app to life—a ground breaking
                  resolution that redefines restaurant experiences.
                </p>
              </div>
              <div className="banner_btn">
                <Link to="https://apps.apple.com/us/app/reckn/id1637403461">
                  <StaticImage
                    src="../../../images/case-studies/amj/app_store.webp"
                    alt="TekRevol"
                    className=""
                    layout="constrained"
                    placeholder="blurred"
                    formats={["png"]}
                    width={164}
                    height={60}
                  />
                </Link>
                <Link to="https://play.google.com/store/apps/details?id=com.app.reckn.host&pli=1">
                  <StaticImage
                    src="../../../images/case-studies/amj/google_play.webp"
                    alt="TekRevol"
                    className="btn_amj "
                    layout="constrained"
                    placeholder="blurred"
                    formats={["png"]}
                    width={164}
                    height={60}
                  />
                </Link>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Banner;
